if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]') || this.querySelector('[name="add"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (this.submitButton && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        document.addEventListener('product-form:validate', () => {
          this.updateSubmitButtonState();
          this.refreshValidationMessage();
        });
        setTimeout(() => this.updateSubmitButtonState(), 0);
      }

      getValidationScope() {
        return this.closest('product-info') || document;
      }

      isEcPdpValidationActive() {
        const pi = this.closest('product-info');
        if (!pi) return false;
        if (pi.getAttribute('data-ec-pdp-modulos') === 'true') return true;
        const chooseOptions = pi.querySelectorAll(
          '.ec-pdp-choose-option:not([data-option-type="height"]):not([data-oc-role="optional"]):not(.ec-pdp-oc-block--optional)'
        );
        if (chooseOptions.length > 0) return true;
        const heightSelects = pi.querySelectorAll('.ec-height-select');
        for (let hi = 0; hi < heightSelects.length; hi++) {
          const hs = heightSelects[hi];
          if (hs.closest('.ec-native-variant-chooser')) continue;
          if (hs.closest('.ec-nvc-optional-section')) continue;
          return true;
        }
        if (pi.querySelector('.ec-pdp-option-cards [data-oc-role="required"]')) return true;
        return false;
      }

      isCalculadoraSatisfied() {
        const scope = this.getValidationScope();
        const rug = scope.querySelector('.ec-calculadora:not(.ec-calculadora-mesa)');
        if (rug) {
          const larguraInput = rug.querySelector('input[id^="ec-calculadora-largura-"]');
          const alturaInput = rug.querySelector('input[id^="ec-calculadora-altura-"]');
          if (larguraInput && alturaInput) {
            const largura = parseFloat(larguraInput.value, 10);
            const altura = parseFloat(alturaInput.value, 10);
            if (!(largura > 0 && altura > 0 && !Number.isNaN(largura) && !Number.isNaN(altura))) return false;
          }
        }
        const mesa = scope.querySelector('.ec-calculadora-mesa');
        if (mesa) {
          const mesaGate = mesa.closest('.ec-mesa-calculator-gate');
          if (mesaGate && mesaGate.getAttribute('data-ec-mesa-gate') === 'true') {
            const gateStyle = window.getComputedStyle(mesaGate);
            if (gateStyle.display === 'none') return true;
          }
          const inputLargura = mesa.querySelector('.ec-calculadora-mesa__largura');
          const inputComprimento = mesa.querySelector('.ec-calculadora-mesa__comprimento');
          if (inputLargura && inputComprimento) {
            const larguraMin = parseFloat(mesa.getAttribute('data-largura-min'), 10) || 0;
            const larguraMaxAttr = mesa.getAttribute('data-largura-max');
            const larguraMax =
              larguraMaxAttr !== null && larguraMaxAttr !== '' ? parseFloat(larguraMaxAttr, 10) : null;
            const comprimentoMin = parseFloat(mesa.getAttribute('data-comprimento-min'), 10) || 0;
            const stepM = 0.2;
            const mesaOk = (val, min, max) => {
              if (val === '' || val === null) return false;
              const num = parseFloat(String(val).trim().replace(',', '.'));
              if (Number.isNaN(num)) return false;
              if (num < min) return false;
              if (max !== null && num > max) return false;
              const n = Math.abs(num) / stepM;
              return Math.abs(n - Math.round(n)) < 1e-6;
            };
            if (!mesaOk(inputLargura.value, larguraMin, larguraMax)) return false;
            if (!mesaOk(inputComprimento.value, comprimentoMin, null)) return false;
          }
        }
        return true;
      }

      getOcRequiredBlock() {
        const scope = this.getValidationScope();
        return scope.querySelector('.ec-pdp-option-cards [data-oc-role="required"]');
      }

      ocRequiredSizesVisible(reqBlock) {
        if (!reqBlock) return false;
        const sizesEl = reqBlock.querySelector('.ec-pdp-oc-sizes');
        if (!sizesEl) return false;
        return window.getComputedStyle(sizesEl).display !== 'none';
      }

      getPrimaryHeightSelect() {
        const scope = this.getValidationScope();
        const list = scope.querySelectorAll('.ec-height-select');
        for (let i = 0; i < list.length; i++) {
          const hs = list[i];
          if (hs.closest('.ec-nvc-optional-section')) continue;
          return hs;
        }
        return null;
      }

      isOcRequiredSizeSatisfied() {
        const req = this.getOcRequiredBlock();
        if (!req) return true;
        if (!req.querySelector('.ec-pdp-choose-option__item.selected')) return true;
        if (!this.ocRequiredSizesVisible(req)) return true;
        const sv = req.querySelector('.ec-pdp-oc__size-val');
        return !!(sv && sv.value && String(sv.value).trim());
      }

      computeCurrentValidationMessage() {
        const strings = window.productFormStrings || {};
        if (!this.isCalculadoraSatisfied()) {
          return strings.fillCalculadora || 'Please fill in the calculator fields with valid values.';
        }
        if (!this.isEcPdpValidationActive()) return null;
        const scope = this.getValidationScope();
        const allOptions = scope.querySelectorAll(
          '.ec-pdp-choose-option:not([data-option-type="height"]):not([data-oc-role="optional"]):not(.ec-pdp-oc-block--optional)'
        );
        const unselectedOptions = [];
        allOptions.forEach((option) => {
          if (!option.querySelector('.ec-pdp-choose-option__item.selected')) unselectedOptions.push(option);
        });
        if (unselectedOptions.length > 0) {
          return unselectedOptions.length === 1
            ? strings.selectOption || 'Please select an option before adding to cart.'
            : (strings.selectOptionsCount || 'Please select all options ([count] pending) before adding to cart.').replace(
                '[count]',
                String(unselectedOptions.length)
              );
        }
        const heightSelect = this.getPrimaryHeightSelect();
        if (heightSelect) {
          const selectedOption = heightSelect.querySelector('.ec-height-select__option--selected');
          const customHeightValue = heightSelect.getAttribute('data-custom-height-value') || 'Custom Height (Specify in form)';
          const customInput = heightSelect.querySelector('.ec-height-select__custom-input');
          if (!selectedOption) {
            return strings.selectSeatHeight || 'Please select a seat height.';
          }
          const selectedValue = selectedOption.getAttribute('data-value') || '';
          if (selectedValue === '') {
            return strings.selectSeatHeight || 'Please select a seat height.';
          }
          if (selectedValue === customHeightValue && customInput && !customInput.value.trim()) {
            return strings.specifyCustomHeight || 'Please specify your custom height.';
          }
        }
        if (!this.isOcRequiredSizeSatisfied()) {
          return strings.selectModuleDimension || 'Please select a module dimension.';
        }
        return null;
      }

      refreshValidationMessage() {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper || this.errorMessageWrapper.hasAttribute('hidden')) return;

        if (this.isFormValid()) {
          this.handleErrorMessage(false);
          return;
        }
        const msg = this.computeCurrentValidationMessage();
        if (msg) this.handleErrorMessage(msg);
      }

      isFormValid() {
        if (!this.isCalculadoraSatisfied()) return false;
        if (!this.isEcPdpValidationActive()) return true;
        const scope = this.getValidationScope();
        const allOptions = scope.querySelectorAll(
          '.ec-pdp-choose-option:not([data-option-type="height"]):not([data-oc-role="optional"]):not(.ec-pdp-oc-block--optional)'
        );
        for (const option of allOptions) {
          if (!option.querySelector('.ec-pdp-choose-option__item.selected')) return false;
        }
        const heightSelect = this.getPrimaryHeightSelect();
        if (heightSelect) {
          const selectedOption = heightSelect.querySelector('.ec-height-select__option--selected');
          if (!selectedOption) return false;
          const selectedValue = selectedOption.getAttribute('data-value') || '';
          if (selectedValue === '') return false;
          const customHeightValue = heightSelect.getAttribute('data-custom-height-value') || 'Custom Height (Specify in form)';
          const customInput = heightSelect.querySelector('.ec-height-select__custom-input');
          if (selectedValue === customHeightValue && customInput && !customInput.value.trim()) return false;
        }
        if (!this.isOcRequiredSizeSatisfied()) return false;
        return true;
      }

      updateSubmitButtonState() {
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('data-variant-state')) return;
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
      }

      parseNvcStoredOptionals(productId) {
        if (!productId) return [];
        try {
          const raw = sessionStorage.getItem('ec_nvc_' + productId);
          if (!raw) return [];
          const d = JSON.parse(raw);
          if (!d || !Array.isArray(d.opts)) return [];
          return d.opts.filter(function (o) {
            return o && o.variantId && o.optModName;
          });
        } catch (e) {
          return [];
        }
      }

      buildMainLineItemFromFormData(formData) {
        const id = parseInt(formData.get('id'), 10);
        const quantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1);
        const item = { id: id, quantity: quantity };
        const properties = {};
        for (const pair of formData.entries()) {
          const key = pair[0];
          const value = pair[1];
          if (!key.startsWith('properties[')) continue;
          const m = /^properties\[(.+)\]$/.exec(key);
          if (m && value !== '') properties[m[1]] = String(value);
        }
        if (Object.keys(properties).length) item.properties = properties;
        const sp = formData.get('selling_plan');
        if (sp) {
          const spn = parseInt(sp, 10);
          item.selling_plan = isNaN(spn) ? sp : spn;
        }
        return item;
      }

      async buildNvcBundledAddPayload(formData) {
        const pi = this.closest('product-info');
        if (!pi || pi.getAttribute('data-ec-pdp-modulos') !== 'true') return null;
        if (!pi.querySelector('.ec-native-variant-chooser')) return null;
        const productId = pi.dataset.productId;
        const stored = this.parseNvcStoredOptionals(productId);
        if (!stored.length) return null;

        const cartRes = await fetch((routes.cart_url || '/cart').replace(/\/?$/, '') + '.js');
        if (!cartRes.ok) return null;
        const cart = await cartRes.json();

        const existingOptVariants = (cart.items || [])
          .filter(function (it) {
            return it.properties && (it.properties._ec_nvc_optional === '1' || it.properties._ec_nvc_optional === 1);
          })
          .map(function (it) {
            return it.variant_id;
          });

        const seenIds = {};
        const missing = stored.filter(function (opt) {
          const vid = parseInt(opt.variantId, 10);
          if (isNaN(vid)) return false;
          if (seenIds[vid]) return false;
          seenIds[vid] = true;
          const inCart = existingOptVariants.some(function (ev) {
            return parseInt(ev, 10) === vid;
          });
          return !inCart;
        });

        if (!missing.length) return null;

        // ID de grupo que vincula o item pai aos opcionais para remoção conjunta no carrinho.
        const groupKey = 'ec_nvc_group_' + productId;
        let groupId = '';
        try { groupId = sessionStorage.getItem(groupKey) || ''; } catch (e) {}
        if (!groupId) {
          groupId = 'g-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
          try { sessionStorage.setItem(groupKey, groupId); } catch (e) {}
        }

        const mainItem = this.buildMainLineItemFromFormData(formData);
        mainItem.properties = mainItem.properties || {};
        mainItem.properties._ec_nvc_group = groupId;
        const optionalItems = missing.map(function (opt) {
          return {
            id: parseInt(opt.variantId, 10),
            quantity: 1,
            properties: {
              _ec_nvc_module: opt.optModName,
              _ec_nvc_optional: '1',
              _ec_nvc_group: groupId,
              _ec_nvc_instance:
                Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10),
            },
          };
        });

        const sectionIds = this.cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
        return {
          items: [mainItem].concat(optionalItems),
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        };
      }

      handleCartAddSuccess(response, formData, evt) {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
          if (!soldOutMessage) return;
          if (this.submitButton) this.submitButton.setAttribute('aria-disabled', true);
          if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;

        // Item pai (e seus opcionais) já estão no carrinho com o _ec_nvc_group atual.
        // Limpa o grupo para que a próxima configuração gere um novo, evitando que
        // pais distintos compartilhem o mesmo grupo.
        try {
          const pi = this.closest('product-info');
          if (pi && pi.dataset.productId) {
            sessionStorage.removeItem('ec_nvc_group_' + pi.dataset.productId);
          }
        } catch (e) {}

        const quickAddModal = this.closest('quick-add-modal');

        const renderCart = () => {
          try {
            const cartDrawer = this.cart || document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(response);
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          } catch (error) {
            console.error('Error rendering cart:', error);
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          }
        };

        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                if (typeof CartPerformance !== 'undefined' && CartPerformance.measure) {
                  CartPerformance.measure('add:paint-updated-sections', renderCart);
                } else {
                  renderCart();
                }
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          const startMarker =
            typeof CartPerformance !== 'undefined' ? CartPerformance.createStartingMarker('add:wait-for-subscribers') : null;

          if (typeof CartPerformance !== 'undefined' && CartPerformance.measure) {
            CartPerformance.measure('add:paint-updated-sections', renderCart);
          } else {
            renderCart();
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            }).then(() => {
              if (startMarker && typeof CartPerformance !== 'undefined') {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              }
            });
          }
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (!this.validateRequiredOptions()) {
          if (this.submitButton) {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
          }
          const loadingSpinner = this.querySelector('.loading__spinner');
          if (loadingSpinner) loadingSpinner.classList.add('hidden');
          return;
        }

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        const formData = new FormData(this.form);

        const selectedOptions = this.getSelectedOptions();
        selectedOptions.forEach((option) => {
          formData.append(`properties[_${option.name}]`, option.value);
        });

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        const run = async () => {
          let bundledPayload = null;
          if (this.cart) {
            bundledPayload = await this.buildNvcBundledAddPayload(formData);
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';

          if (bundledPayload) {
            config.body = JSON.stringify(bundledPayload);
          } else {
            delete config.headers['Content-Type'];
            if (this.cart) {
              formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
              formData.append('sections_url', window.location.pathname);
            }
            config.body = formData;
          }

          const response = await fetch(`${routes.cart_add_url}`, config).then((r) => r.json());
          this.handleCartAddSuccess(response, formData, evt);
        };

        run()
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          const isUnavailable = text === window.variantStrings?.unavailable;
          const isSoldOut = text === window.variantStrings?.soldOut;
          if (isUnavailable) {
            this.submitButton.setAttribute('data-variant-state', 'unavailable');
          } else if (isSoldOut) {
            this.submitButton.setAttribute('data-variant-state', 'sold-out');
          } else {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text && this.submitButtonText) this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('data-variant-state');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings?.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      scrollToVariantPicker() {
        const scope = this.closest('product-info') || document;
        const variantSelects = scope.querySelector('variant-selects');
        if (!variantSelects) return;
        variantSelects.scrollIntoView({ behavior: 'smooth', block: 'center' });
        variantSelects.classList.add('ec-variant-error');
        setTimeout(() => variantSelects.classList.remove('ec-variant-error'), 2500);
      }

      validateRequiredOptions() {
        const variantState = this.submitButton?.getAttribute('data-variant-state');
        if (variantState === 'sold-out') {
          const modal = document.getElementById('ec-modal-br');
          if (modal && typeof modal.open === 'function') modal.open();
          return false;
        }
        if (
          variantState === 'unavailable' ||
          (!variantState && !this.variantIdInput?.value && !this.isEcPdpValidationActive())
        ) {
          this.handleErrorMessage(
            window.productFormStrings?.selectVariant ||
            'Por favor, selecione uma opção disponível.'
          );
          this.scrollToVariantPicker();
          return false;
        }

        if (!this.isCalculadoraSatisfied()) {
          this.handleErrorMessage(this.computeCurrentValidationMessage());
          return false;
        }
        if (!this.isEcPdpValidationActive()) {
          this.handleErrorMessage(false);
          return true;
        }
        const scope = this.getValidationScope();
        const allOptions = scope.querySelectorAll(
          '.ec-pdp-choose-option:not([data-option-type="height"]):not([data-oc-role="optional"]):not(.ec-pdp-oc-block--optional)'
        );
        const unselectedOptions = [];

        allOptions.forEach((option) => {
          const selectedItem = option.querySelector('.ec-pdp-choose-option__item.selected');
          if (!selectedItem) {
            unselectedOptions.push(option);
          }
        });

        if (unselectedOptions.length > 0) {
          const firstUnselectedOption = unselectedOptions[0];
          this.openAccordion(firstUnselectedOption);
          this.handleErrorMessage(this.computeCurrentValidationMessage());
          return false;
        }

        const heightSelect = this.getPrimaryHeightSelect();
        if (heightSelect) {
          const targetInput = scope.querySelector('.ec-height-select__input-target');
          const selectedOption = heightSelect.querySelector('.ec-height-select__option--selected');
          const customHeightValue = heightSelect.getAttribute('data-custom-height-value') || 'Custom Height (Specify in form)';
          const customInput = heightSelect.querySelector('.ec-height-select__custom-input');

          if (!selectedOption) {
            this.handleErrorMessage(this.computeCurrentValidationMessage());
            const heightOption = heightSelect.querySelector('.ec-pdp-choose-option') || heightSelect.closest('.ec-pdp-choose-option');
            if (heightOption) this.openAccordion(heightOption);
            return false;
          }

          const selectedValue = selectedOption.getAttribute('data-value') || '';
          if (selectedValue === '') {
            this.handleErrorMessage(this.computeCurrentValidationMessage());
            const heightOption = heightSelect.querySelector('.ec-pdp-choose-option') || heightSelect.closest('.ec-pdp-choose-option');
            if (heightOption) this.openAccordion(heightOption);
            return false;
          }

          if (selectedValue === customHeightValue && customInput) {
            const customVal = customInput.value.trim();
            if (!customVal) {
              this.handleErrorMessage(this.computeCurrentValidationMessage());
              const heightOption = heightSelect.querySelector('.ec-pdp-choose-option') || heightSelect.closest('.ec-pdp-choose-option');
              if (heightOption) this.openAccordion(heightOption);
              customInput.focus();
              return false;
            }
            if (targetInput) targetInput.value = customVal;
          }
        }

        const ocReq = this.getOcRequiredBlock();
        if (ocReq && ocReq.querySelector('.ec-pdp-choose-option__item.selected') && !this.isOcRequiredSizeSatisfied()) {
          this.handleErrorMessage(this.computeCurrentValidationMessage());
          this.openAccordion(ocReq);
          const trigger = ocReq.querySelector('.ec-pdp-oc-size-trigger');
          if (trigger) {
            trigger.focus();
            trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return false;
        }

        this.handleErrorMessage(false);
        return true;
      }

      openAccordion(optionElement) {
        const content = optionElement.querySelector('.ec-pdp-choose-option__content');
        const title = optionElement.querySelector('.ec-pdp-choose-option__title');
        
        if (!content || !title) return;

        function getContentHeight() {
          const previews = Array.from(content.querySelectorAll('.ec-pdp-choose-option__item-preview')).filter((p) => !p.closest('.ec-pdp-choose-option__mobile-preview'));
          previews.forEach((p) => { p.style.display = 'none'; });
          const originalHeight = content.style.height;
          content.style.height = 'auto';
          const height = content.scrollHeight;
          content.style.height = originalHeight || '0px';
          previews.forEach((p) => { p.style.display = ''; });
          return height;
        }

        if (!optionElement.classList.contains('expanded')) {
          const currentHeight = getContentHeight();
          content.style.height = currentHeight + 'px';
          content.style.opacity = '1';
          optionElement.classList.add('expanded');
        }

        setTimeout(() => {
          title.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }, 100);
      }

      getChooseOptionGroupLabel(optionContainer) {
        const titleEl = optionContainer.querySelector('.ec-pdp-choose-option__title');
        if (!titleEl) return '';
        const clone = titleEl.cloneNode(true);
        clone.querySelectorAll('.ec-pdp-choose-option__icon').forEach((el) => el.remove());
        return clone.textContent.replace(/\s+/g, ' ').trim();
      }

      getSelectedOptions() {
        const scope = this.getValidationScope();
        const allOptions = scope.querySelectorAll(
          '.ec-pdp-choose-option:not([data-oc-role="optional"]):not(.ec-pdp-oc-block--optional)'
        );
        const selectedOptions = [];

        allOptions.forEach((optionContainer) => {
          if (optionContainer.closest('.ec-native-variant-chooser')) return;
          const selectedItem = optionContainer.querySelector('.ec-pdp-choose-option__item.selected');
          if (selectedItem) {
            const groupLabel = this.getChooseOptionGroupLabel(optionContainer);
            const optionName =
              selectedItem.getAttribute('data-option-name') || groupLabel || '';
            const optionDisplay = selectedItem.getAttribute('data-option-display') || '';
            const optionValue = selectedItem.getAttribute('data-option-value') || '';
            const valueToPass = optionDisplay || optionValue;

            if (optionName && valueToPass) {
              selectedOptions.push({
                name: optionName,
                value: valueToPass
              });
            }
          }
        });

        return selectedOptions;
      }
    }
  );
}
